import { Spinner } from 'react-bootstrap'
import Schedule from './Schedule'
import useBookings from '../hooks/useBooking'

const ScheduleContainer = () => {
  const { bookings } = useBookings(true, (booking) => !booking.cancelled)

  if (bookings) {
    return (
      <Schedule bookings={bookings} />
    )
  }

  return (
    <Spinner animation="border" role="status" variant="info" />
  )
}

export default ScheduleContainer
